import { render } from "./delete-article.vue?vue&type=template&id=e9ed7516&ts=true"
import script from "./delete-article.vue?vue&type=script&lang=ts"
export * from "./delete-article.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__